import { CSSObject } from "@emotion/react";
import { constants, cssVariableStyles } from "@newsela/angelou";
const {
  colors: { ui },
} = constants;
const { generateIconColorCss } = cssVariableStyles;

const coreBlue500 = ui.core[500];
const coreBlue600 = ui.blue[600];

export const blueIconCss = generateIconColorCss({ primaryColor: coreBlue500 });

export const DataValueOrIconContainerCss: CSSObject = {
  display: "flex",
  alignItems: "center",
  alignContent: "center",
  gap: "16px",
  justifyContent: "left",
};

export const statValueNumberCss: CSSObject = {
  position: "relative",
  color: ui.core[700],
  fontFamily: "Circular",
  fontWeight: 700,
  lineHeight: "125%",
  display: "block",
};

export const smallPercentageSymbolCss: CSSObject = {
  fontSize: "16px",
};

export const defaultVariantCss: CSSObject = {
  fontSize: "32px",
};

export const defaultVariantWithStatValueCSS: CSSObject = {
  marginTop: "16px",
};

export const statValueCircleVariantCss: CSSObject = {
  width: "68px",
  height: "68px",
  marginTop: 0,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "24px",
};

export const circleShapeCss: CSSObject = {
  position: "absolute",
  width: "68px",
  backgroundColor: "white",
  height: "68px",
  borderRadius: "50%",
};

export const circleShapeWithProgressVariantCss: CSSObject = {
  border: "1px solid #AAC9F5",
};

export const progressCircleCss = (percentValue = 33): CSSObject => {
  /**
   * CSS technique is from https://www.freecodecamp.org/news/css-only-pie-chart/
   */

  const roundedPercentValue = Math.round(
    Math.min(100, Math.max(0, percentValue)),
  );

  return {
    width: "73px",
    height: "73px",
    position: "absolute",
    borderRadius: "50%",
    background: `conic-gradient(${coreBlue500} ${roundedPercentValue}%, transparent 0%) border-box`,
    mask: `radial-gradient(farthest-side, transparent calc(100% - 6px), ${coreBlue500} calc(100% - 6px))`,

    "&::before": {
      content: '""',
      position: "absolute",
      borderRadius: "50%",
      inset: 0,
      background: `radial-gradient(farthest-side,${coreBlue500} 98%,#0000) top/6px 6px no-repeat, conic-gradient(${coreBlue500} calc(${roundedPercentValue}*1%),#0000 0)`,
    },

    "&::after": {
      content: '""',
      position: "absolute",
      borderRadius: "50%",
      inset: "calc(50% - 6px/2)",
      background: coreBlue500,
      transform: `rotate(calc(${percentValue}*3.6deg)) translateY(calc(50% - 73px/2))`,
    },
  };
};

export const progressCircleVariantCss: CSSObject[] = [
  statValueCircleVariantCss,
];

export const iconContainerCss: CSSObject = {
  width: "58px",
  height: "58px",
  zIndex: 1,
};

export const statusTextCss: CSSObject = {
  color: coreBlue600,
  fontSize: "16px",
  fontWeight: 700,
};
